"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _icons = require("@material-ui/icons");
var _saraivaUi = require("@minha-biblioteca/saraiva-ui");
var _ChaptersList = _interopRequireDefault(require("../ChaptersList"));
var _BookmarksList = _interopRequireDefault(require("../BookmarksList"));
var _HighlightsList = _interopRequireDefault(require("../HighlightsList"));
var _contexts = require("../../contexts");
var _services = require("../../services");
var _utils = require("../../utils");
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable react/jsx-no-bind */

// Components

// Contexts

// Services

// Styles

function Drawer() {
  var HASH = 'menu';
  var [hash, setHash] = (0, _react.useState)(global.location.hash);
  var classes = (0, _styles.default)();
  var {
    openDrawer,
    setOpenDrawer,
    tabSelected,
    onHashChangeCallback,
    setOnHashChangeCallback
  } = (0, _react.useContext)(_contexts.SideBarContext);
  var {
    setHighlightColor
  } = (0, _react.useContext)(_contexts.HighlightsContext);
  var {
    sessionToken,
    uuid,
    bookTitle
  } = (0, _react.useContext)(_contexts.EpubReaderContext);
  var appToken = (0, _utils.appTokenCase)(window.location.origin);
  var service = (0, _services.TrackingsService)(appToken, sessionToken);
  (0, _react.useEffect)(() => {
    function onHashChange() {
      if (onHashChangeCallback) {
        onHashChangeCallback();
        setOnHashChangeCallback();
      }
    }
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, [onHashChangeCallback, setOnHashChangeCallback]);
  (0, _react.useEffect)(() => {
    function onBackNavigation() {
      if (hash.includes(HASH)) {
        setOpenDrawer(false);
      }
      setHash(global.location.hash);
    }
    window.addEventListener('hashchange', onBackNavigation);
    return () => window.removeEventListener('hashchange', onBackNavigation);
  }, [hash, setOpenDrawer]);
  (0, _react.useEffect)(() => {
    if (openDrawer) {
      global.location.hash = HASH;
    } else if (global.location.hash.includes(HASH)) {
      window.history.back();
    }
  }, [openDrawer]);
  var handleCloseDrawer = () => {
    setOpenDrawer(false);
    setHighlightColor();
  };
  function trackingHighlightBookmark(indexValue) {
    if (indexValue === 1) {
      service.trackAccessHighlight({
        uuid,
        titleCover: bookTitle
      });
    }
    if (indexValue === 2) {
      service.trackAccessBookmark({
        uuid,
        titleCover: bookTitle
      });
    }
  }
  function handleBookTitle(str) {
    var words = str.split(' ');
    words.forEach((word, index) => {
      if (words[index].length === 2) {
        words[index] = word.toLowerCase();
      } else {
        words[index] = word.charAt(0).toUpperCase() + word.substr(1).toLowerCase();
      }
    });
    var title = decodeURI(words.join(' '));
    return /*#__PURE__*/_react.default.createElement(_core.Typography, {
      variant: "body1",
      className: classes.title
    }, title);
  }
  return /*#__PURE__*/_react.default.createElement(_core.Drawer, {
    className: classes.drawer,
    anchor: "left",
    open: openDrawer,
    classes: {
      paper: classes.drawerPaper
    },
    onClose: handleCloseDrawer
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.drawerHeader
  }, handleBookTitle(bookTitle), /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    "aria-label": "fechar",
    onClick: handleCloseDrawer
  }, /*#__PURE__*/_react.default.createElement(_icons.Close, {
    classes: {
      root: classes.drawerClose
    }
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.overrideTab
  }, /*#__PURE__*/_react.default.createElement(_saraivaUi.Tabs, {
    variant: "scrollable",
    color: "primary",
    mode: "grow",
    showDivider: true,
    onChange: event => trackingHighlightBookmark(event),
    selectedTabIndex: tabSelected
  }, [{
    label: 'CAPÍTULOS',
    content: /*#__PURE__*/_react.default.createElement("div", {
      className: classes.tabContent
    }, /*#__PURE__*/_react.default.createElement(_ChaptersList.default, null))
  }, {
    label: 'DESTAQUES E NOTAS',
    content: /*#__PURE__*/_react.default.createElement("div", {
      className: classes.tabContent
    }, /*#__PURE__*/_react.default.createElement(_HighlightsList.default, null))
  }, {
    label: 'PÁGINAS MARCADAS',
    content: /*#__PURE__*/_react.default.createElement("div", {
      className: classes.tabContent
    }, /*#__PURE__*/_react.default.createElement(_BookmarksList.default, null))
  }])));
}
var _default = exports.default = Drawer;